import React, {useRef} from "react";
import {CloseMobile, NewModal, NewModalContainer} from "../../../../components/ui/Content";
import {useOnClickOutside} from "../../../../hooks/useClickOutside";
import {Close} from "../../../../icon/Icon";
import {ChangePasswordForm} from "./ChangePasswordForm";

let modalEl: HTMLDivElement;

interface IChangePasswordModalProps {
    onClose: () => void
}

export const ChangePasswordModal = ({onClose}: IChangePasswordModalProps) => {

    const ref = useRef(modalEl);
    useOnClickOutside(ref, () => onClose())

    return <NewModal>
        <CloseMobile onClick={onClose}>
            <Close/>
        </CloseMobile>
        <NewModalContainer ref={ref}>
            <ChangePasswordForm onClose={onClose}/>
        </NewModalContainer>
    </NewModal>
}
